<section class="playground">
  <h2 class="playground__heading">Pagination buttons</h2>
  <p class="playground__hint">
    <code>common-pagination-buttons</code> usa internamente
    <a href="https://material.angular.dev/components/paginator/overview" rel="noopener noreferrer" target="_blank"
      >mat-paginator</a
    >
    pero solo muestra los botones de navegación (Figma: <code>Pagination_buttons</code>): círculos con borde
    <code>primary/blue/b_70</code>, sin ripple ni texto de rango ni selector de ítems por página.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>length (total ítems)</span>
        <input type="number" [(ngModel)]="length" min="0" />
      </label>

      <label class="playground__field">
        <span>pageIndex (inicial)</span>
        <input type="number" [(ngModel)]="pageIndex" min="0" />
      </label>

      <label class="playground__field">
        <span>pageSize (inicial)</span>
        <input type="number" [(ngModel)]="pageSize" min="1" />
      </label>

      <label class="playground__field">
        <span>size</span>
        <select [(ngModel)]="size">
          <option *ngFor="let s of sizes" [value]="s">{{ s }}</option>
        </select>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="hidePageSize" />
        <span>hidePageSize</span>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="showFirstLastButtons" />
        <span>showFirstLastButtons</span>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>

      <label class="playground__field">
        <span>ariaLabel</span>
        <input type="text" [(ngModel)]="ariaLabel" />
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box playground__preview-box--pagination">
        <common-pagination-buttons
          [length]="length"
          [pageIndex]="pageIndex"
          [pageSize]="pageSize"
          [showFirstLastButtons]="showFirstLastButtons"
          [disabled]="disabled"
          [ariaLabel]="ariaLabel"
          [size]="size"
          (page)="onPage($event)"
        ></common-pagination-buttons>
      </div>
      <p class="playground__meta" *ngIf="lastEvent">
        Último <code>PageEvent</code>: pageIndex={{ lastEvent.pageIndex }}, pageSize={{ lastEvent.pageSize }}, length={{ lastEvent.length }}
      </p>
    </div>
  </div>
</section>
